import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CTASection from '@/components/feature/CTASection';
import SEOHead from '@/components/base/SEOHead';

const SITE_URL = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env?.VITE_SITE_URL as string) || '';

const teamMembers = [
  {
    title: '負責人',
    name: '邱鼎霖',
    nameEn: 'Ding-Lin, Qiu',
    position: '財稅管理 × 企業經營 × AI 與永續轉型顧問',
    bio: '邱鼎霖具備財稅專業與上市公司財會管理經驗，長期關注企業經營管理、財務制度、稅務合規與數位轉型。以國家考試及格記帳士、AI 提示工程與 ESG 碳管理相關專業背景，協助企業在升級過程中兼顧策略、合規與執行效益。',
    highlights: [
      '國家考試及格記帳士',
      '上市公司財務、會計與成本管理經驗',
      '商標註冊與智慧財產權佈局諮詢',
      'ISO/IEC 17024 AI 提示工程師資歷',
      'ISO 14064-1 溫室氣體盤查主導稽核員',
      'ISO 14067 產品碳足跡主導稽核員',
    ],
    image: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/e214e767b61a998b73438c77a03f3c32.jpeg'
  },
  {
    title: '總工程師',
    name: '陳昱麟',
    nameEn: 'Yu-Lin, Chen',
    position: '資訊系統整合 × 工廠自動化 × AI 應用落地',
    bio: '陳昱麟以使用者需求與現場流程為核心，擅長規劃一條龍資訊串接與系統整合方案，協助企業降低人工作業成本，提升資料管理、設備監控與營運效率。',
    highlights: [
      '機器設備連網與監視控制',
      '工廠產線網頁管理平台設計',
      'AI 規劃整合與大數據應用',
      '自動化系統與工廠資訊管理經驗',
      '服務經驗涵蓋鋼鐵、石化、電子、製造與能源相關產業',
    ],
    image: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/84bfc507a4d4e4955e5c48c4a263a6ae.jpeg'
  },
  {
    title: '專案總監',
    name: '吳美華',
    nameEn: 'Mei-Hua, Wu',
    position: '政府資源整合 × 數位轉型 × 企業營運升級',
    bio: '吳美華專注於企業升級輔導、政府資源對接與數位轉型規劃，擅長協助餐飲業、服務業與製造業釐清升級方向，並將 AI 工具、行銷流程與營運改善導入實務場景。',
    highlights: [
      '跨產業輔導與專案整合經驗',
      '政府補助與輔導資源規劃',
      'AI 生成式工具應用與流程優化',
      '企業電子化規劃',
      'ISO/IEC 17024 國際 AI 生成指導師相關專業',
    ],
    image: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/a0202e7682e0249bc05e5857c27174b1.jpeg'
  },
  {
    title: '財務總監',
    name: '陳姍亭',
    nameEn: 'Shan-Ting, Chen',
    position: '財稅顧問 × 創業輔導 × 企業財務後援',
    bio: '陳姍亭具備國家認證記帳士專業，專注於帳務、稅務、財務報表與企業財務管理。以合法、準確、穩健為核心，協助企業主建立可信任的財稅基礎。',
    highlights: [
      '稅務規劃與財稅顧問',
      '創業輔導與公司設立諮詢',
      '勞健保、人事與初期財務架構建議',
      'ESG 永續與電子化規劃',
      '投資、簽證、審計與銀行資源對接',
    ],
    image: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/3b0864ba83a94ebeed060c0195479388.jpeg'
  },
  {
    title: '協理',
    name: '陳姵閔',
    nameEn: 'CHEN PEI MIN',
    position: '永續碳健檢諮詢 × 產學育成整合 × AI 數位轉型應用',
    bio: '陳姵閔具備深厚的企業數位升級與永續經營顧問背景。現任商研院碳健檢顧問，專注於協助企業在淨零碳排趨勢下精準接軌國際標準；同時擔任康寧大學育成中心顧問，積極串聯產學資源、引進前沿科技。陳姵閔亦榮獲 ISO/IEC 17024 AI 提示工程師認證，致力將生成式 AI 技術融入企業實務流程，協助產業在永續與數位雙軸轉型中建立核心競爭力。',
    highlights: [
      '商研院碳健檢顧問',
      '康寧大學育成中心顧問 (115)',
      'ISO/IEC 17024 AI 提示工程師資歷',
      '企業淨零碳排與永續諮詢',
      '產學合作與資源整合規劃',
    ],
    image: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/101578b357e51dcedad61f1f4b405865.jpeg'
  },
];

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  '@id': `${SITE_URL}/about#aboutpage`,
  name: '關於得運智科 | 得運智科股份有限公司',
  url: `${SITE_URL}/about`,
  description: '得運智科股份有限公司成立於 2024 年，位於台中七期，專注於企業升級轉型顧問服務。由具備財稅、AI、專案管理與 ESG 專業背景的顧問組成。',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首頁', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: '關於得運智科', item: `${SITE_URL}/about` },
    ],
  },
  about: {
    '@type': 'Organization',
    name: '得運智科股份有限公司',
    url: SITE_URL,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '市政北二路 236 號 20 樓 15 室',
      addressLocality: '台中市',
      addressRegion: '西屯區',
      postalCode: '407',
      addressCountry: 'TW',
    },
    telephone: '+886-909-518-828',
    email: 'abc10616@gmail.com',
    foundingDate: '2024',
  },
  mainEntity: {
    '@type': 'ItemList',
    itemListElement: teamMembers.map((m, i) => ({
      '@type': 'Person',
      position: i + 1,
      name: m.name,
      jobTitle: m.title,
      description: m.position,
      worksFor: {
        '@type': 'Organization',
        name: '得運智科股份有限公司',
      },
    })),
  },
};

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="關於得運智科 | 得運智科股份有限公司"
        description="得運智科成立於 2024 年，位於台中七期，專注企業升級轉型顧問服務。團隊整合財稅管理、AI 應用、產官學資源、ESG 碳管理與專案執行能力。認識我們的專業團隊。"
        keywords="得運智科, 關於我們, 企業顧問, 專業團隊, 公司簡介, 台中企業顧問"
        canonicalPath="/about"
        ogType="website"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero with background image */}
        <section className="relative min-h-[400px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_ff862ddf32729919761aee120059c399_115a0f79.jpg"
              alt="得運智科團隊"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-primary-900/35 via-primary-900/20 to-primary-900/45" />
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center pt-16">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
              關於得運智科
            </h1>
            <p className="text-sm md:text-base text-white/90 max-w-2xl mx-auto leading-relaxed">
              我們相信，企業升級不只是導入工具或申請資源，而是要把策略、財務、技術與永續管理整合成可落地的行動方案。
            </p>
          </div>
        </section>

        {/* Company Intro */}
        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-6 lg:px-8 max-w-5xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
              <div className="w-full lg:w-1/2">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  公司簡介
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    得運智科股份有限公司成立於 2024 年，位於台中七期，專注於企業升級轉型顧問服務。團隊整合財稅管理、AI 應用、產官學資源、ESG 碳管理與專案執行能力，協助企業在快速變動的市場環境中，找到更穩健的成長方向。
                  </p>
                  <p>
                    我們服務的核心，不只是提供資訊，而是陪伴企業完成從「問題診斷」到「策略規劃」、從「資源對接」到「執行落地」的完整過程，讓企業能更有效率地運用外部資源，強化內部管理能力。
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <div className="rounded-xl overflow-hidden border border-background-200">
                  <img
                    src="https://public.readdy.ai/ai/img_res/edited_6af69e62644a68df855a91f5ea4f25bb_afcfaeb2.jpg"
                    alt="得運智科辦公環境"
                    className="w-full h-64 md:h-80 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Philosophy */}
        <section className="bg-primary-900 py-16 md:py-24">
          <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 leading-tight">
              以智慧賦能企業，以專業協助落地
            </h2>
            <p className="text-sm md:text-base text-white/85 leading-relaxed">
              得運智科致力於成為企業主身邊可信任的轉型夥伴。我們重視實務可行性，也重視合規與長期效益。無論是政府輔導資源、AI 工具導入、財稅管理優化或 ESG 永續規劃，我們都以企業實際需求為起點，協助每一項計畫真正產生價值。
            </p>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-6 lg:px-8">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
                專業團隊
              </h2>
              <p className="text-sm md:text-base text-foreground-700 max-w-2xl mx-auto leading-relaxed">
                得運智科由具備財稅、AI、專案管理與 ESG 專業背景的顧問組成，致力於為企業提供全方位升級支持。
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto">
              {teamMembers.map((member) => (
                <div
                  key={member.name}
                  className="bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-colors duration-300 w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] max-w-[380px]"
                >
                  <div className="h-64 md:h-72 overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">
                      {member.title}
                    </span>
                    <h3 className="text-lg font-bold text-foreground-950 mt-1">
                      {member.name}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-1">
                      {member.nameEn}
                    </p>
                    <p className="text-xs text-primary-700 font-medium mb-3">
                      {member.position}
                    </p>
                    <p className="text-xs text-foreground-700 leading-relaxed mb-4">
                      {member.bio}
                    </p>
                    <div className="flex flex-wrap gap-1.5">
                      {member.highlights.map((highlight) => (
                        <span
                          key={highlight}
                          className="px-2 py-1 bg-primary-50 text-primary-800 text-xs rounded-md border border-primary-100"
                        >
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </div>
  );
}